import { motion } from 'framer-motion';
import { projects } from '../../config';

const ProjectsTab = () => {
  return (
    <main>
      <section className="pt-20 pb-20">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-4xl font-bold mb-4 text-center text-gray-900 dark:text-white">Featured Projects</h2>
            <p className="text-center text-gray-600 dark:text-gray-400 mb-12 max-w-2xl mx-auto">
              A showcase of real-world projects from my 12+ year journey—from Android apps to enterprise 
              fintech platforms. Each project represents challenges solved and value delivered.
            </p>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {projects.map((project, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  whileHover={{ y: -10 }}
                  className="glass-effect rounded-xl overflow-hidden card-hover group"
                >
                  <div className={`h-48 ${project.image} flex items-center justify-center relative overflow-hidden`}>
                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors duration-300" />
                    <h3 className="text-2xl font-bold text-white z-10 px-4 text-center">
                      {project.title}
                    </h3>
                  </div>
                  
                  <div className="p-6">
                    <p className="text-gray-700 dark:text-gray-300 mb-4 line-clamp-3">
                      {project.description}
                    </p>
                    
                    <div className="flex flex-wrap gap-3 mb-4">
                      {project.technologies.map((tech, techIndex) => {
                        const IconComponent = tech.icon;
                        return (
                          <div 
                            key={techIndex}
                            className="flex items-center gap-1 text-sm bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full"
                          >
                            <IconComponent className={tech.color} />
                            <span className="dark:text-white">{tech.name}</span>
                          </div>
                        );
                      })}
                    </div>
                    
                    {/* Links hidden for now */}
                    {/* <div className="flex gap-4">
                      <a
                        href={project.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
                      >
                        <FaGithub /> Code
                      </a>
                      <a
                        href={project.live}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
                      >
                        <FaExternalLinkAlt /> Live Demo
                      </a>
                    </div> */}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default ProjectsTab;
  